export default __webpack_public_path__ + "static/media/card-01.ed2389e6.svg";